// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  webServices: {
    SistemaProyectos: 'https://projectvestaapi-stg.azurewebsites.net/api/',
    FileShareApi: 'https://filesharewebapi-stage.azurewebsites.net/'
    //SistemaProyectos: 'https://projectvestaapi.vesta-accelerate.com/api/',
    //FileShareApi: 'https://fileshareapi.vesta-accelerate.com/'
  },
  web: {
    FileShare: 'https://fileshareweb-stage.azurewebsites.net/'
    //FileShare: 'https://fileshare.vesta-accelerate.com/'
  },
  urlWebNueva: {
    URL: 'https://solicituddeproyectos.vestadev-accelerate.com/'
    //URL: 'https://solicituddeproyectos.vesta-accelerate.com/'
  }
};
